/**
 * An automation's stable identity for list keys and API payloads.
 *
 * `Automation` is an assembled view, not a row, so it has no `id` of its own:
 * grouped automations are keyed by the shared `automationGroupId`, singles by
 * their one member rule's id, and a group that somehow carries neither falls
 * back to its name. Defined once here (F-065) because the same expression had
 * been written out at each listing site.
 */
export function automationKey(a) {
    return a.groupId ?? a.branches.find((b) => b.ruleId)?.ruleId ?? a.name;
}
//# sourceMappingURL=automation-model.js.map